import { gql } from "@apollo/client";

export const TRANSACTIONS = gql`
  query Transactions($where: TransactionWhereInput, $skip: Int, $take: Int) {
    transactions(where: $where, skip: $skip, take: $take) {
      data {
        id
        hex
        base64
        type
        txid
      }
      count
    }
  }
`;

export const TRANSACTION = gql`
  query Transaction($where: TransactionWhereInput) {
    transaction(where: $where) {
      id
      meta
      status
      transactions {
        id
        hex
        base64
        type
        txid
      }
      collateral {
        assets {
          usdValue
          id
          type
          content {
            meta
            node
          }
          action {
            id
            type
            configuration
          }
        }
      }
    }
  }
`;

const transaction = { TRANSACTIONS, TRANSACTION };

export default transaction;
